import { Box, Grid, styled, Typography } from "@mui/material";
import React from "react";
import appcolors from "../../../constants/Colors";

const MainView = styled(Box)(({ theme }) => ({
  position: "relative",
  backgroundColor: "#ffffff",
  maxWidth: "1000px",
  margin: "auto",
  padding: "16px",

  "& .lpl_rs_pr": {
    fontSize: "2.5rem",
    fontWeight: 700,
    color: "#161C2D",
    [theme.breakpoints.down("sm")]: {
      fontSize: "2rem",
    },
  },
  "& .lpl_rs_sr": {
    fontSize: "1.8rem",
    fontWeight: 600,
    color: "#161C2D",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.5rem",
    },
  },
}));

const loginSteps = [
  {
    step: 1,
    description:
      "Just register your self using email or phone number if you don’t have a account on",
  },
  {
    step: 2,
    description:
      "You will receive OTP on your mobile if you select a mobile otherwise verification code on your email address which you enter.",
  },
  {
    step: 3,
    description: "Verify your account and login.",
  },
];

function RegisterSteps() {
  const renderSteps = () => {
    return loginSteps?.map((val, ind) => {
      return (
        <Box mt={3} key={ind}>
          <Typography variant="h1" className="lpl_rs_sr">
            Step {val.step}
          </Typography>
          <Typography
            mt={1.5}
            fontWeight={300}
            variant="body1"
            color={"#161C2D"}
          >
            {val.description}{" "}
            {val.step == 1 && (
              <span style={{ fontWeight: "bold", color: appcolors.primary }}>
                LOBA{" "}
              </span>
            )}
          </Typography>
        </Box>
      );
    });
  };
  return (
    <MainView my={{ xs: 3, md: 6 }}>
      <Grid container>
        <Grid item xs={12} md={6}>
          <Typography variant="h1" className="lpl_rs_pr">
            Client start with us
          </Typography>
          <Typography variant="h1" className="lpl_rs_pr">
            Login/Sign Up
          </Typography>
          <Typography
            mt={1.5}
            fontWeight={300}
            variant="body1"
            color={"#161C2D"}
          >
            "Our app features a simple login and sign-up process, making it
            quick and easy to get started. Just a few taps and"
          </Typography>
          <Typography
            variant="body1"
            color={"primary.main"}
            fontStyle={"italic"}
          >
            You're ready to manage your appointments and services.
          </Typography>
          {renderSteps()}
        </Grid>
      </Grid>
    </MainView>
  );
}

export default RegisterSteps;
